export default {
      id: "i-question-small-usage",
      viewBox: "0 0 17 17",
      url: __webpack_public_path__ + "img/sprite.svg#i-question-small",
      toString: function () {
        return this.url;
      }
    }